<template>
  <div class="bg-bkk-25 p-5 md:p-10 mx-auto">
    <div class="flex flex-row justify-center max-w-[405px] mx-auto">
      <div class="flex flex-col">
        <div v-if="contentSection.appointmentTeaserImage">
          <img
            :src="contentSection.appointmentTeaserImage"
            alt="appointment teaser image"
            class="w-full sm:w-[405px] h-[228px] object-cover rounded-lg"
          />
        </div>
        <p class="mt-1 text-sm">{{ t("appointment.info.text") }}</p>
        <h3 class="text-lg">
          {{ helperFunctions.limitString(contentSection.appointmentName, 76) }}
        </h3>
        <p v-if="contentSection.appointmentTeaserText" class="mt-1">
          {{
            helperFunctions.limitString(
              contentSection.appointmentTeaserText,
              80
            )
          }}
        </p>
        <div v-if="contentSection.startAt" class="flex flex-row mt-4">
          <StartIcon class="bg-white rounded-full" />
          <p class="ml-2">
            {{
              dateManager.formatDateGermanFormatWithTime(
                contentSection.startAt
              ) +
              " " +
              t("appointment.oclock")
            }}
          </p>
        </div>
        <div v-if="contentSection.endAt" class="flex flex-row mt-1">
          <EndIcon class="bg-white rounded-full" />
          <p class="ml-2">
            {{
              dateManager.formatDateGermanFormatWithTime(contentSection.endAt) +
              " " +
              t("appointment.oclock")
            }}
          </p>
        </div>
        <ButtonContentSection
          :label="t('appointment.details.button.caption')"
          :icon="ArrowRight"
          class="w-40 mt-6"
          @click="articleAppointmentModalOpen = true"
        />
        <ArticleAppointmentModal
          :open="articleAppointmentModalOpen"
          :appointment="contentSection"
          @close="articleAppointmentModalOpen = false"
        />
      </div>
    </div>
    <CalendarIcon
      class="right-1 translate-x-[-25px] translate-y-[-65px] md:translate-y-[-45px] absolute ml-auto fill-bkk-75"
    />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { getCurrentInstance } from "vue";
import ButtonContentSection from "../layout/button/ButtonContentSection.vue";
import { AppointmentDto } from "../../../dto/appointment.dto";
import StartIcon from "~/components/v2/icon/StartIcon.vue";
import EndIcon from "~/components/v2/icon/EndIcon.vue";
import ArticleAppointmentModal from "~/components/v2/contentSections/ArticleAppointmentModal.vue";
import CalendarIcon from "~/components/v2/icon/CalendarIcon.vue";
import ArrowRight from "~/components/v2/icon/ArrowRight.vue";

defineProps<{
  contentSection: AppointmentDto;
}>();
const { t } = useI18n();
const articleAppointmentModalOpen = ref(false);

const { appContext } = getCurrentInstance()!;
const helperFunctions = appContext.config.globalProperties.$helperFunctions;
const dateManager = appContext.config.globalProperties.$dateManager;
</script>
